import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';

export interface DeleteConfirmationComponentData {
  sysText: any;
  deleteConfirm2: string;
}

@Component({
    selector: 'app-delete-confirmation',
    templateUrl: './delete-confirmation.component.html',
    styleUrls: ['./delete-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteConfirmationComponent {
  static readonly componentName = 'DeleteConfirmationComponent';

  public position = position;
  public onDragEnded = onDragEnded;

  constructor(@Inject(MAT_DIALOG_DATA)
    public data: DeleteConfirmationComponentData
  ) { }
}
